import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestStop } from '../models/rest-stop';

@Injectable({
  providedIn: 'root',
})
export class BottomSheetService {
  private selectedRestStopSubject = new BehaviorSubject<RestStop | null>(null);
  public selectedRestStop$: Observable<RestStop | null> = this.selectedRestStopSubject.asObservable();

  private closingSubject = new BehaviorSubject<boolean>(false);
  public isClosing$: Observable<boolean> = this.closingSubject.asObservable();

  private openingSubject = new BehaviorSubject<boolean>(false);
  public isOpening$: Observable<boolean> = this.openingSubject.asObservable();

  constructor() {}

  open(restStop: RestStop): void {
    // Reset closing flag; only set opening flag when transitioning from closed to open
    this.closingSubject.next(false);
    const wasClosed = this.selectedRestStopSubject.getValue() === null;
    if (wasClosed) {
      this.openingSubject.next(true);
    }
    this.selectedRestStopSubject.next(restStop);
  }

  endOpening(): void {
    this.openingSubject.next(false);
  }

  startClosing(): void {
    // Ensure opening flag is cleared when closing starts
    this.openingSubject.next(false);
    this.closingSubject.next(true);
  }

  close(): void {
    // When the sheet is fully closed, clear selection and reset flags
    this.selectedRestStopSubject.next(null);
    this.closingSubject.next(false);
    this.openingSubject.next(false);
  }

  public isBottomSheetOpen(): boolean {
    return this.selectedRestStopSubject.getValue() !== null;
  }
}
